import { render, staticRenderFns } from "./DsGeneralCards.vue?vue&type=template&id=c1b6c3e0&scoped=true"
import script from "./DsGeneralCards.vue?vue&type=script&lang=js"
export * from "./DsGeneralCards.vue?vue&type=script&lang=js"
import style0 from "./DsGeneralCards.vue?vue&type=style&index=0&id=c1b6c3e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b6c3e0",
  null
  
)

export default component.exports